import { create } from 'zustand'

import { STORAGE_KEYS } from '@/lib/api/storageKeys'

/**
 * **표시용 미러**(설계 불변식 1).
 *
 * 🚨 여기에 `isAuthenticated` 를 두지 않는다 — 세션 유효성의 답은 `tokenStore.hasValidSession()`
 * 하나다. 인터셉터(React 밖)와 가드(React 안)가 서로 다른 소스를 보면 어긋난다.
 *
 * 로그인 응답 바디가 비어 있어(T1) 서버가 주는 회원 표시 정보가 없다. 톱바에 무엇이라도
 * 보여주기 위해 **사용자가 입력한 로그인 아이디**를 저장한다.
 */
interface AuthState {
  loginId: string | null
  setLoginId: (loginId: string) => void
  clearLoginId: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  loginId: localStorage.getItem(STORAGE_KEYS.loginId),

  setLoginId: (loginId) => {
    localStorage.setItem(STORAGE_KEYS.loginId, loginId)
    set({ loginId })
  },

  clearLoginId: () => {
    localStorage.removeItem(STORAGE_KEYS.loginId)
    set({ loginId: null })
  },
}))
